import { useQuery } from "@tanstack/react-query";
import type { ReactNode } from "react";

import { api, query, type Schemas } from "../api/client.ts";

/**
 * Las sugerencias que el usuario se escribe a si mismo en Ajustes y luego toca
 * aqui para rellenar un campo de texto.
 *
 * Existen por una razon muy concreta: el momento de escribir la tesis es justo
 * cuando menos ganas hay de escribir, con la operacion delante. Una frase a un
 * toque es la diferencia entre dejar constancia y no dejarla.
 */

export type Suggestion = Schemas["SuggestionDto"];
export type SuggestionField = Suggestion["field"];

export function useSuggestions(field: SuggestionField) {
  return useQuery({
    queryKey: ["suggestions", field],
    queryFn: () =>
      api.get<Suggestion[]>(`/api/v1/settings/sugerencias${query({ field })}`),
    staleTime: 5 * 60_000,
  });
}

export function Suggestions(props: {
  field: SuggestionField;
  value?: string;
  onPick: (text: string) => void;
}): ReactNode {
  const suggestions = useSuggestions(props.field);
  const items = suggestions.data ?? [];

  if (items.length === 0) return null;

  return (
    <div className="sugs">
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          className={props.value === item.text ? "sug-card sel" : "sug-card"}
          onClick={() => props.onPick(item.text)}
        >
          {item.text}
        </button>
      ))}
    </div>
  );
}
